import { Fragment, useEffect, useState } from "react";
import { Transition } from "@headlessui/react";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/outline";
import { XIcon } from "@heroicons/react/solid";
import { usePage } from "@inertiajs/inertia-react";

export default () => {
    const [showSuccess, setShowSuccess] = useState(true);
    const [showError, setShowError] = useState(true);
    const { flash } = usePage().props;

    useEffect(() => {
        setShowSuccess(true);
        setShowError(true);

        const interval = setInterval(() => {
            setShowSuccess(false);
            setShowError(false);
        }, 3000);
        return () => {
            clearTimeout(interval);
        };
    }, [flash]);

    return (
        <>
            <div
                aria-live="assertive"
                className="pointer-events-none fixed inset-0 mt-12 flex items-end px-4 py-6 sm:items-start sm:p-6"
            >
                <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
                    {flash.success && (
                        <Transition
                            show={showSuccess}
                            as={Fragment}
                            enter="transform ease-out duration-300 transition"
                            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                                <div className="p-4">
                                    <div className="flex items-start">
                                        <div className="flex-shrink-0">
                                            <CheckCircleIcon
                                                className="h-6 w-6 text-green-400"
                                                aira-hidden="true"
                                            />
                                        </div>
                                        <div className="ml-3 w-0 flex-1 py-0.5">
                                            <p className="text-sm font-medium text-gray-900">
                                                Successfully Completed
                                            </p>
                                            <p className="mt-1 text-sm text-gray-500">
                                                {flash.success}
                                            </p>
                                        </div>
                                        <div className="ml-4 flex flex-shrink-0">
                                            <button
                                                onClick={() =>
                                                    setShowSuccess(false)
                                                }
                                                className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                            >
                                                <span className="sr-only">
                                                    Close
                                                </span>
                                                <XIcon
                                                    className="h-5 w-5"
                                                    aria-hidden={true}
                                                />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Transition>
                    )}
                    {flash.error && (
                        <Transition
                            show={showError}
                            as={Fragment}
                            enter="transform ease-out duration-300 transition"
                            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                                <div className="p-4">
                                    <div className="flex items-start">
                                        <div className="flex-shrink-0">
                                            <XCircleIcon
                                                className="h-6 w-6 text-red-400"
                                                aira-hidden="true"
                                            />
                                        </div>
                                        <div className="ml-3 w-0 flex-1 py-0.5">
                                            <p className="text-sm font-medium text-gray-900">
                                                Opps there was an error
                                            </p>
                                            <p className="mt-1 text-sm text-gray-500">
                                                {flash.error}
                                            </p>
                                        </div>
                                        <div className="ml-4 flex flex-shrink-0">
                                            <button
                                                onClick={() =>
                                                    setShowError(false)
                                                }
                                                className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                            >
                                                <span className="sr-only">
                                                    Close
                                                </span>
                                                <XIcon
                                                    className="h-5 w-5"
                                                    aria-hidden={true}
                                                />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Transition>
                    )}
                </div>
            </div>
        </>
    );
};
